import { RiZoomInLine } from 'react-icons/ri'
import Empty from '../empty/Empty'
import './gallery.css'

const Gallery = ({data, isGallery, isSetModal, isSetObj}) => {

      if(!isGallery) return 

      const openModal = (item) => {
            isSetObj(item)
            isSetModal(true)
      }

      return (
            <div className={isGallery ? "pager_content show" : "pager_content"}>
                  <div className="header_page">
                        <span className="bg_grad">Photos</span>
                  </div>
                  <div className={!data.data ? "section_page gallery" : "section_page"}>
                        {
                              (!data.data)
                                    ?
                                          data.map((item, index) => (
                                                <div className="card_gallery" key={index}>
                                                      <img src={item.image} alt={item.description} />
                                                      <button className="btn_gallery" onClick={() => openModal(item)}><RiZoomInLine /></button>
                                                </div>
                                          ))
                                    : <Empty text={"Oops! Not Image Added"}/>
                        }
                        
                  </div>
            </div>
      )
}

export default Gallery
